import NewsSingle from "./news/single";

if (document.body.classList.contains("-detail")) {
    const single = new NewsSingle();
}
